import { render } from "./GPUDevicesTab.vue?vue&type=template&id=1fead4b9&scoped=true"
import script from "./GPUDevicesTab.vue?vue&type=script&lang=js"
export * from "./GPUDevicesTab.vue?vue&type=script&lang=js"

import "./GPUDevicesTab.vue?vue&type=style&index=0&id=1fead4b9&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fead4b9"]])

export default __exports__